import React, { useState, useEffect } from "react";
import Checkbox from '@mui/material/Checkbox';
import Mycart from "./Mycart";
import deleteIcon from "../../assets/iposub/deleteIcon.svg";
import IPODialog from "./IPODialog";
import { useNotificationActionsContext } from "../../components/notificationModal/useModal";
const IPOCommonBiding = ({
    bidDetails,
    updatesetbidDetails,
    ipoDetails,
    bidingReason,
    isModify,
    onDeleteBid,
    noWarnings=false,
    selectionType,
}) => {
    const notCheckable=true
    if(ipoDetails.Indetails){
        ipoDetails = ipoDetails.Indetails
    }
    const existingBids = ipoDetails.BidingDetails?.bids
    const showAlert = useNotificationActionsContext();

    console.log(ipoDetails)
    console.log(bidDetails);


    const limits = {
        "Retail":                   2,
        "Employee - Retail":        5,
        "Shareholders - Retail":    5,
        "Policy Holder - Retail":   5,
    }

    const maxBidAmount = (100000 * (limits[selectionType]||2))
  
    bidDetails = bidDetails.sort((a, b) => {
        return a.id - b.id;
      });
   
    // console.log(localBidDetails)

    useEffect(() => {
        
        if(ipoDetails.BidingDetails){

        }

    }, []);
    const [decDisable, setdecDisable] = useState(true)
    const [incDisable, setincDisable] = useState(false)

    const incrementQuantity = (bid, index) => {

        let bids = [...bidDetails]
        let bidCart = bid.cart;
        let calQuantity = (Number(bidCart.quantity) + Number(ipoDetails.LotSize));
        let calPrice = (Number(bidCart.price) * Number(calQuantity))
        if ((calPrice) < maxBidAmount) {
            // setdecDisable(false)
            // setincDisable(false)
            // if (Number(itemsOld.finalPrice) < maxBidAmount) {
            bidCart.quantity = calQuantity;
            bidCart.finalPrice = calPrice;
            bidCart.incBlock = false;
            bidCart.decBlock = false;
            let newBid = { ...bids[index] };
            newBid.cart = bidCart;
            bids[index] = newBid;
            // setbidDetails(items);
            updatesetbidDetails(bids);
        } else {

            const errMessages = {
                "Retail":  "As a Retail Investor the application limit is up to 2 lakhs.",
                "Employee - Retail":  "Under Employee category, the application limit is up to 5 lakhs.",
                "Shareholders - Retail":  "Under Shareholders category, the application limit is up to 5 lakhs.",
                "Policy Holder - Retail":  "Under Policyholders category, the application limit is up to 5 lakhs.",
            }

            const errorMessage = errMessages[selectionType]||''
            //  `Investors can only purchase applications upto Rs. 2 lakhs`
            showAlert({val:true,msg:errorMessage})
            // alert(Number(itemsOld.finalPrice));
            // setdecDisable(false)
            // setincDisable(true)
            bidCart.incBlock = true;
            bidCart.decBlock = false;
            let bids = [...bidDetails];
            let newBid = { ...bids[index] };
            newBid.cart = bidCart;
            bids[index] = newBid;
        }

        validatePrice(bid,index,bids)

    }

    const decrementQuantity = (bid, index) => {

        let bidCart = bid.cart;
        let bids = [...bidDetails];

        if (bidCart.quantity > ipoDetails.LotSize) {
            // setdecDisable(false)
            // setincDisable(false)
            bidCart.quantity = (bidCart.quantity - ipoDetails.LotSize);
            bidCart.finalPrice = (Number(bidCart.price) * Number(bidCart.quantity));
            bidCart.incBlock = false;
            bidCart.decBlock = false;
            let newBid = { ...bids[index] };
            newBid.cart = bidCart;
            bids[index] = newBid;
            // setbidDetails(items);
            updatesetbidDetails(bids);
        } else {
            bidCart.decBlock = true;
            bidCart.incBlock = false;
            let bids = [...bidDetails];
            let newBid = { ...bids[index] };
            newBid.cart = bidCart;
            bids[index] = newBid;
            // setdecDisable(true)
            // setincDisable(false)
        }
        validatePrice(bid,index,bids)
    }


    const updateCheckbox = (bid, index) => {
 
        const isCutoff = !bid.cutoffprice
        const alreadyOneCutoff = bidDetails.some(it => !!it.cutoffprice) 
        if(alreadyOneCutoff && isCutoff){
            showAlert({val:true,msg: 'Only one bid can have cut-off price'})
            return 
        }

        // for(let i=0;i<bidDetails.length;i++){
        //     bidDetails[i].cutoffprice = false
        // }

        
        let bids = [...bidDetails];
        let newBid = { ...bids[index] };

        newBid.cutoffprice = isCutoff;
        newBid.price_error = '';

        
        newBid.cart = bid.cart;
        newBid.cart.price = ipoDetails.MaxPrice;
        bids[index] = newBid;
        console.log(newBid,bids)
        
        updatesetbidDetails(bids)
        validatePrice(newBid,index,bids)
    }
    const 
    validatePrice = (bid, index ,bids) => {

        bids = bids || [...bidDetails];
        let newBid = { ...bids[index] };
        newBid.price_error = "";


        const minPrice = Number(ipoDetails.MinPrice)
        const maxPrice = Number(ipoDetails.MaxPrice)

 
        if (Number(newBid.cart.price) >= minPrice && Number(newBid.cart.price) <= maxPrice) {

            newBid.price_error = '';
            bids[index] = newBid;
            // setbidDetails(items);
            updatesetbidDetails(bids)
        } else {
            newBid.price_error = `Price should be between ${minPrice} - ${maxPrice}`;
            bids[index] = newBid;
            // setbidDetails(items);
            updatesetbidDetails(bids)
        }
        if(Number(newBid.cart.price) * Number(newBid.cart.quantity) > maxBidAmount){
            newBid.price_error = `Highest bid value cannot exceed 2 Lakhs`;
        }

    }
    const updatePrice = (newPrice, bid, index) => {

        // bid.price_error = "";

        let bids = [...bidDetails];
        let newBid = { ...bids[index] };
        newBid.price_error = ""
        newBid.cart.price = newPrice
        
        bids[index] = newBid;
        // setbidDetails(items);

        updatesetbidDetails(bids)
    }


    const [deleteId, setdeleteId] = useState('');
    const deleteThis = (that) => {
        // show modal 
        setdeleteId(that);
        setopenDialog(true)

    }
    const [openDialog, setopenDialog] = useState(false)
    const closestatus = (that) => {
        setopenDialog(false);
        if (that == 'yes') {
            onDeleteBid?.(bidDetails.find(bid => bid.id == deleteId))
            let localDate = bidDetails.filter(bid => bid.id != deleteId);

            updatesetbidDetails(localDate)
            setdeleteId('')
        }
    }

    const onAddingItem = (i, index) => (event) => {
        let bids = [...bidDetails];
        let newBid = { ...bids[index] };
        newBid.selectstatus = !newBid.selectstatus;
        bids[index] = newBid;
        updatesetbidDetails(bids);
    }


    const showView = () => {

        switch (openDialog) {
            case false:
                return (
                    <></>
                )
            case true:
                return (
                    // <></>
                    <IPODialog openstatus={openDialog} closestatus={closestatus} confirmationName={'deletepopup'} TitleName='' />
                )
        }
    }

  

    return (
        <>
            {

                bidDetails && bidDetails.map((biddetail, index) => {
                    const existingBid = existingBids?.[index]
                    const editable  = existingBid?.can_modify_flag != "N"
                    const deletable = !isModify || existingBid?.can_cancel_flag != 'N'
                    const isDisabled = isModify && !editable

                    const bidTotal = biddetail.cart.quantity * biddetail.cart.price 

                    return <div className="bidedetailsDiv" key={biddetail.id}>

                        <div className="row hideMobileiposub">
                            <div className="col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="parentFlex">
                                    <div className="bidOneDiv">

                                        {
                                            bidingReason === 'cancel' && !notCheckable && 
                                            <Checkbox
                                                label=""
                                                disabled={isDisabled}
                                                style={{ transform: "scale(0.5)", }}
                                                sx={{
                                                    color: '#343D7E',
                                                    '&.Mui-checked': {
                                                        color: '#343D7E',
                                                    },
                                                }}
                                                value={biddetail.id}
                                                checked={biddetail.selectstatus}
                                                onChange={onAddingItem(biddetail, index)}
                                            />
                                        }


                                        <div className="bidBox">
                                            Bid {(index + 1)}
                                        </div>
                                    </div>
                                    <div className="bidTwoDiv">

                                        {
                                            bidingReason == 'cancel' &&
                                            <>
                                                <p className="lotLable">No. of shares:</p>
                                                <p className="lotValue ms-2">{biddetail.cart?.quantity}</p></>
                                        }
                                        {
                                            bidingReason == 'modify' &&
                                            <>
                                                <Mycart
                                                    cart={biddetail}
                                                    index={index}
                                                    incrementQuantity={incrementQuantity}
                                                    decrementQuantity={decrementQuantity}
                                                    decDisableinput={decDisable}
                                                    incDisableinput={incDisable}
                                                    disabled={isDisabled}
                                                />
                                                <p className="lotLable">No. of shares</p>
                                            </>
                                        }
                                        {/* <p className="lotValue">{biddetail.lotsize}</p> */}
                                    </div>
                                    <div className="bidThreeDiv">
                                        <input type="checkbox" className="checkbox" checked={biddetail.cutoffprice} 
                                        disabled={isDisabled||bidingReason === 'cancel'}
                                        onChange={() => updateCheckbox(biddetail, index)}
                                         />
                                        <p className="lotLable">Cut-off Price</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="parentFlex" style={{flexDirection:'column',alignItems:'stretch'
                                    ,position:'relative'
                                }}>
                                <div className="parentFlex">
                                    <div className="bidSecondDivInput">
                                        <p className="lotLable">Price:</p>
                       
                                        {
                                            (biddetail.cutoffprice == true ||  bidingReason === 'cancel') &&
                                            <p className="lotValue" >₹ {biddetail.price}</p>
                                        }

                                        {

                                            biddetail.cutoffprice == false && bidingReason !== 'cancel' &&
                                            <div className="inpuerror">
                                                <input type="number" value={biddetail.cart.price} className="priceImput"  
                                                     disabled={isDisabled}
                                                     style={{minWidth:'80px'}}
                                                onChange={
                                                    (e) => {
                                                        updatePrice(e.target.value, biddetail, index)
                                                    }
                                                } onBlur={() => validatePrice(biddetail, index)} />
                                            </div>
                                        }

                                    </div>
                 
                                    {/* <div className="bidSecondDiv bidSecondDivbiding">
                                        {
                                            biddetail.bid_refno && biddetail.bid_refno != '' &&

                                            <p className="lotLableorderid">Order ID: {biddetail.bid_refno}</p>

                                        }
                                    </div> */}


                                    <div className="d-flex ms-3">
                                        <p className="lotValue">Total</p>
                                        <p className="lotLable ms-2 me-2">
                                           ₹{prettyPrice(bidTotal)}
                                        </p>
                                    </div>

                                    {
                                        bidDetails.length > 1 && bidingReason === 'modify' &&
                                        <div className="bidSecondDiv juend">
                                            <button className={`alighRight ${deletable?'':' opacity-50  '} 
                                            bg-transparent border-0`}
                                            disabled={!deletable}
                                            onClick={() => deleteThis(biddetail.id)}

                                            >
                                                <img src={deleteIcon} alt="deleteIcons" className="deleImg" />
                                            </button>
                                        </div>
                                    }
                                </div>
                                <>
                                    {
                                        !!biddetail.price_error &&
                                        <p className="m-0"
                                            style={{
                                                bottom:'0px',left:'0px',position:'absolute',
                                                // transform:'TranslateY(20px)',
                                                color:'red',fontSize:'0.8em',
                                            }}
                                        >
                                            {biddetail.price_error}
                                        </p>
                                    }
                                </>
                                </div>
                            </div>

                            <div className="d-flex ps-4">
                                    
                                {existingBid?.bid_refno  && 

                                    <div className="d-flex me-5"
                                        style={{
                                            fontSize:'0.8em'
                                        }}
                                    >
                                        {/* <span style={{
                                            marginRight:'6px'
                                        }}>
                                            Ref no:
                                        </span> */}
                                        <span
                                            style={{
                                                fontWeight:'bold',
                                            }}
                                        >
                                            {existingBid?.bid_refno || ''}
                                        </span>

                                    </div>
                                }


                                <span style={{
                                    fontSize:'0.8em'
                                }}>
                                    <span style={{
                                        // fontWeight:'bold',
                                        marginRight:'6px'
                                    }}>
                                        Status:
                                    </span>
                                    <span style={{
                                        fontWeight:'bold',
                                        marginRight:'6px',

                                    }}>
                                    {existingBid?.status || 'New'}
                                    </span>

                                </span>

                            </div>
                        </div>

                        {/* <!--mobile */}
                        <div className="row showMobileIPOModify">

                            <div className="row col-sm-10 col-10 rightborder">
                                <div className="col-sm-4 col-4 ">

                                    {
                                        bidingReason === 'cancel' && !notCheckable && 
                                        <Checkbox
                                            label=""

                                            style={{ transform: "scale(0.5)", }}
                                            sx={{
                                                color: '#343D7E',
                                                '&.Mui-checked': {
                                                    color: '#343D7E',
                                                },
                                            }}
                                            value={biddetail.id}
                                            checked={biddetail.selectstatus}
                                            onChange={onAddingItem(biddetail, index)}
                                        />
                                    }

                                    <div className="bidBox">
                                        Bid {(index + 1)}
                                    </div>
                                </div>

                                <div className="col-sm-8 col-8">
                                    <div className="mobFlexInbt">
                                        {
                                            bidingReason == 'cancel' &&
                                            <div className="lineheightmobile">
                                                <p className="lotLable">No of shares:</p>
                                                <p className="lotValue">{biddetail.cart?.quantity}</p></div>
                                        }
                                        {
                                            bidingReason == 'modify' &&
                                            <>

                                                <Mycart
                                                    cart={biddetail}
                                                    index={index}
                                                    incrementQuantity={incrementQuantity}
                                                    decrementQuantity={decrementQuantity} />

                                                <p className="lotLable">Lot Size</p>
                                            </>
                                        }
                                    </div>
                                </div>

                                <div className="col-sm-4 col-4 marginExtra">
                                    <div className="disppBloc">
                                        <input type="checkbox" className="checkbox" checked={biddetail.cutoffprice} onChange={() => updateCheckbox(biddetail, index)}
                                        disabled={bidingReason === 'cancel'} />
                                        <p className="lotLable" >Cut-off Price</p>
                                    </div>
                                </div>
                                <div className="col-sm-4 col-4 marginExtra">
                                    <div className="disppBloc">
                                        <p className="lotLable">Price:</p>
                                        {
                                            biddetail.cutoffprice == true && bidingReason === 'cancel' &&
                                            <p className="lotValue" >₹ {biddetail.price}</p>
                                        }
                                        {
                                             biddetail.cutoffprice == false && bidingReason === 'cancel' &&
                                            <p className="lotValue" >₹ {biddetail.price}</p>
                                        }

                                        {

                                            biddetail.cutoffprice == false && bidingReason !== 'cancel' &&
                                            <div className="inpuerror">
                                                <input type="text" value={biddetail.price} className="priceImput" onChange={
                                                    (e) => {
                                                        updatePrice(e.target.value, biddetail, index)
                                                    }
                                                } onBlur={() => validatePrice(biddetail, index)} />
                                                {
                                                    <>

                                                        {
                                                            biddetail.price_error != "" &&
                                                            <span>{biddetail.price_error}</span>
                                                        }
                                                    </>
                                                }

                                            </div>
                                        }

                                    </div>

                                </div>
                                <div className="col-sm-4 col-4 marginExtra">
                                    {
                                        biddetail.orderId != '' &&

                                        <p className="lotLableorderid">Order ID: {biddetail.orderId}</p>

                                    }
                                </div>

                            </div>
                            <div className="col-sm-2 col-2">
                                <div className={`alighRight ${!!isDisabled?'  opacity-50 ':'  '}`}>
                                    <img src={deleteIcon} alt="deleteIcons" className="deleImg" onClick={() => deleteThis(biddetail.id)} />
                                </div>
                            </div>

                        </div>
                        {
                            showView()
                        }
                    </div>

                })
            }</>
    )
}

export default IPOCommonBiding;


export function prettyPrice(amount){

    return (amount||0).toLocaleString?.('en-IN') || amount
}